module.exports = __webpack_public_path__ + "img/icon-blogroll3.719c314e.png";